import React from 'react'

import { Formik } from 'formik'
import { useHistory } from 'react-router-dom'

import { ZariContext } from '_zari/context'

import { Button, Form, Col, Divider, Row } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import { IdGen } from 'utils'

import * as PlantillasGeneralesService from 'services/plantillaGeneralContabilidad.service'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar':
      return [
        ...state,
        {
          ...action.payload,
          _idFila: IdGen.newId()
        }
      ]
    case 'actualizar':
      return state.map(val => {
        if (val._idFila === action.payload._idFila) {
          val = {
            ...val,
            ...action.payload
          }
        }
        return val
      })
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const MainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const [detalles, detallesDispatcher] = React.useReducer(
    commonReducer,
    editarData.detalles,
    detalles => {
      return detalles.map(x => ({
        ...x,
        _idFila: IdGen.newId()
      }))
    }
  )

  const mainFormikRef = React.useRef(null)

  const formInitialValues = React.useMemo(() => {
    return {
      origen: editarData.origen || '',
      titulo: editarData.titulo || ''
    }
  }, [editarData])

  const onSubmit = React.useCallback(
    formData => {
      PlantillasGeneralesService.actualizarxId(editarData._id, {
        detalles: detalles,
        ...formData
      })
        .then(() => {
          __zariContext.snack('success', 'El registro se ha actualizado.')
          history.push(`/${CodigosTransaccionesConstant.PLANTILLASGENERALESCONTABILIDAD_LISTA}`)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [detalles, __zariContext, history, editarData._id]
  )

  const clickGuardar = React.useCallback(() => {
    mainFormikRef.current.handleSubmit()
  }, [])

  return (
    <>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit} innerRef={mainFormikRef}>
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <Row>
              <Col md={3}>
                <FormGroups.OrigenFormGroup
                  iError={errors.origen}
                  iTouched={touched.origen}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col md={5}>
                <FormGroups.TituloFormGroup
                  iError={errors.titulo}
                  iTouched={touched.titulo}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
      <Divider />
      <Sections.DetallesSection detalles={detalles} dispatch={detallesDispatcher} />
      <Divider />
      {detalles.length > 0 && (
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickGuardar}>Guardar</Button>
          </Col>
        </Row>
      )}
    </>
  )
}

export default React.memo(MainForm)
